import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {

    fr: {
      translation: {
          "hero_title1": "Logiciel d",
          "hero_title2": "'analyse d'eau",
          "menu_analyse": "Analyse",
          "menu_calcul_volume": "Calcul du volume",
          "menu_historique": "Historique",
          "menu_login": "Se déconnecter",
          "menu_update_available": "Mise à jour disponible",
          "menu_update_current": "À jour",
          "menu_update_checking": "Vérification...",
          "menu_update_error": "Erreur de vérification",
          "menu_update_app_current": "L'application est à jour",
          "menu_update_download": "Télécharger la dernière version",
          "home_analyse": "Analyse", 
          "home_calcule": "Calcul du volume",
          "home_enregistre": "Historique",
          "home_admin": "Administration",

          "form_pref_placecorder": "Référence, nom, société ...",
          "form_volume_bassin": "Volume du bassin",
          "form_volume_bassin_1": "Je connais le volume",
          "form_volume_bassin_2": "Je ne connais pas le volume",
          "form_volume_bassin_3": "Calcul du volume",

          "form_periode_analyse": "Période de l'analyse",
          "form_periode_analyse_1": "en début de saison",
          "form_periode_analyse_2": "en cours de saison",

          "form_type_filtration": "Type de filtration",
          "form_type_filtration_1": "filtre à sable / verre",
          "form_type_filtration_2": "filtre à diatomée",
          "form_type_filtration_3": "filtre à cartouche",
          "form_type_filtration_4": "poche de filtration",
          "form_type_filtration_5": "Temps de filtration journalier (en heure)",
          "form_type_filtration_6": "Durée en heure",

          "form_type_desinfection": "Type de désinfection",
          "form_type_desinfection_1": "chlore galet",
          "form_type_desinfection_2": "chlore liquide",
          "form_type_desinfection_3": "électrolyseur au sel",
          "form_type_desinfection_4": "Taux de sel recommandé par l'appareil (en g/L)",

          "form_type_eau_calcaire": "Eau calcaire",
          "form_type_eau_calcaire_1": "eau moyennement dure",
          "form_type_eau_calcaire_1_1": "TH inférieur à 200mg/L (20°F)",
          "form_type_eau_calcaire_2": "eau dure",
          "form_type_eau_calcaire_2_2": "TH supérieur à 200mg/L (20°F)",
          "form_type_eau_calcaire_3": "eau très dure",
          "form_type_eau_calcaire_3_3": "TH supérieur à 400mg/L (40°F)",
          "form_type_eau_calcaire_4": "je ne sais pas",

          "form_aspect_eau": "Aspect de l'eau",
          "form_aspect_eau_1": "eau claire transparente",
          "form_aspect_eau_2": "eau trouble",
          "form_aspect_eau_3": "eau verte",

          "form_temperature_eau": "Température de l'eau",
          "form_temperature_eau_1": "Température en C°",

          "form_valeur_mesure": "Valeurs mesurées",
          "form_valeur_input_manual": "Je rentre les valeurs manuellement",
          "form_valeur_input_manual_tooltip": "Entrer les valeurs manuellement",
          "form_valeur_input_spintouch": "Je me connecte au SpinTouch",
          "form_valeur_input_spintouch_tooltip": "Se connecter au SpinTouch",
          "form_valeur_input_spintouch_disabled": "Utiliser le logiciel Esprit Piscine sur Windows. Bientôt disponible.",
          "form_valeur_mesure_PH": "Valeur du pH",
          "form_valeur_mesure_CL": "Taux de chlore libre (mg/L)",
          "form_valeur_mesure_BR": "Teneur en brome (mg/L)",
          "form_valeur_mesure_TAC": "Alcanilité ou TAC (mg/L)",
          "form_valeur_mesure_TAC_facultatif": "(facultatif)",
          "form_valeur_mesure_TH": "Dureté totale ou TH (mg/L)",
          "form_valeur_mesure_TH_facultatif":"(facultatif)",
          "form_valeur_mesure_STAB": "Stabilisant (mg/L)",
          "form_valeur_mesure_Phosphate": "Phosphate en ppb",

          "form_valeur_button": "Analyse",


          "simul_volTitre1": "Calculer le volume d'eau",
          "simul_volTitre2": "de votre piscine ou SPA m³",

          "simul_vol2Titre1": "Choisissez la forme du bassin",
          "simul_vol2Titre2": " de votre bassin :",

          "simul_vol3Titre1": "Dimensions de votre bassin",
          "simul_vol3Titre2": " de votre bassin :",

          "simul_Rectangle": "Rectangle",
          "simul_Ovale": "Ovale",
          "simul_Ronde": "Ronde",
         

          "simul_Longueur": "Longueur (m)",
          "simul_Largeur": "Largeur (m)",
          "simul_Profondeur": "Profondeur (m)",
          "simul_ProfondeurMini": "Profondeur mini (m)",
          "simul_ProfondeurMaxi": "Profondeur maxi (m)",
          "simul_Diametre": "Diametre (m)",


          "simul_Button": "Analyse",
          "simul_Button2": "Calcul du volume",

          "histo_search": "Rechercher par data, nom, etc..",

          "histo_Ref": "Référence",



          "analyse_title1": "Données de votre bassin",
          "analyse_info_volume": "Volume du bassin : ",
          "analyse_info_type_filtration": "Type de filtration : ",
          "analyse_info_type_desinfection": "Type de désinfection : ",
          "analyse_info_temperature_eau": "Température de l'eau : ",

          "analyse_titleResultat": "Résultat de l'analyse",

          "analyse_resulat_ideal": "idéal : ",

          "analyse_resulat_download" : "Télécharger l'analyse",
          "analyse_resulat_share" : "Partager l'analyse",

          "analyse_resulat_new" : "Nouvelle analyse",
          "historique_message_supression_title" : "Suppression analyse",
          "historique_message_supression_description" : "Supprimer l'analyse ?",

          "historique_message_supression_button_annuler" : "Annuler",
          "historique_message_supression_button_supprimer" : "Supprimer",


          "analyse_TempsFiltration" : "Temps de filtration",


          "simul_Forme_Rectangle" : "Rectangle",
          "simul_Forme_Oval" : "Ovale",
          "simul_Forme_Ronde" : "Ronde",
          "simul_Forme_Autre" : "Autre forme",

          "home_spintouch": "Spintouch",


          "form_spintouch_non_detect": "Aucun résultat détaillé retourné par l'appareil. Vérifier le branchement de l'appareil.",

          "validation_volume_bassin": "Entrer le volume de votre bassin",
          "validation_type_filtration": "Sélectionner un type de filtration",
          "validation_temps_filtration": "Entrer le temps de filtration journalier de votre bassin en heure",
          "validation_type_desinfection": "Sélectionner un type de désinfection",
          "validation_eau_calcaire": "Compléter l'onglet eau calcaire",
          "validation_aspect_eau": "Sélectionner l'aspect de l'eau",
          "validation_temperature_eau": "Entrer la température de l'eau de votre bassin",
          "validation_niveau_chlore": "Entrer le niveau de chlore de votre bassin",
          "validation_analyse_en_cours": "Analyse en cours...",
          "validation_erreur_analyse": "Erreur lors de l'analyse",

          "simul_validation_type_forme": "Sélectionner le type de forme de votre bassin",
          "simul_validation_longueur": "Entrer la longueur du bassin",
          "simul_validation_largeur": "Entrer la largeur du bassin",
          "simul_validation_profondeur_mini": "Entrer la profondeur minimum du bassin",
          "simul_validation_profondeur_maxi": "Entrer la profondeur maximum du bassin",
          "simul_validation_diametre": "Entrer le diamètre du bassin",
          "simul_resultat_volume": "Votre piscine à un volume d'eau de :",


          



          
          
        }
    },

    en: {
      translation: {
        "hero_title1": "The analysis application",
        "hero_title2": "for pool maintenances",
        "menu_analyse": "Analysis",
        "menu_calcul_volume": "Volume calculation",
        "menu_historique": "Orders",
        "menu_login": "Log out",
        "menu_update_available": "Update available",
        "menu_update_current": "Up to date",
        "menu_update_checking": "Checking...",
        "menu_update_error": "Check failed",
        "menu_update_app_current": "The application is up to date",
        "menu_update_download": "Download the latest version",
        "home_analyse": "I analyze",
        "home_calcule": "I calculate",
        "home_enregistre": "I save",
        "home_admin": "Administration",
        "home_spintouch": "Spintouch",
        "form_pref_placecorder": "Reference, name, compagny ...",
        "form_volume_bassin": "Pool volume",
        "form_volume_bassin_1": "I know the volume",
        "form_volume_bassin_2": "I don't know the volume",
        "form_volume_bassin_3":"I calculate",

        "form_periode_analyse": "Analysis period",
        "form_periode_analyse_1": "at the start of the season",
        "form_periode_analyse_2": "during the season",

        "form_type_filtration": "Filtration type",
        "form_type_filtration_1": "Sand filter",
        "form_type_filtration_2": "Diatomaceous filter",
        "form_type_filtration_3": "Cartridge filter",
        "form_type_filtration_4": "Filtration bag",
        "form_type_filtration_5": "Daily filtration time (in hours)",
        "form_type_filtration_6": "Duration in hours",

        "form_type_desinfection": "Disinfection type",
        "form_type_desinfection_1": "Chlorine tablet",
        "form_type_desinfection_2": "Liquid chlorine",
        "form_type_desinfection_3": "Saltwater chlorinator",
        "form_type_desinfection_4": "Recommended salt level by the device (g/L)",

        "form_type_eau_calcaire": "Hard water",
        "form_type_eau_calcaire_1": "Moderately hard water",
        "form_type_eau_calcaire_1_1": "TH below 200 mg/L (20°F)",
        "form_type_eau_calcaire_2": "Hard water",
        "form_type_eau_calcaire_2_2": "TH above 200 mg/L (20°F)",
        "form_type_eau_calcaire_3": "Very hard water",
        "form_type_eau_calcaire_3_3": "TH above 400 mg/L (40°F)",
        "form_type_eau_calcaire_4": "I don't know	",

        "form_aspect_eau": "Water appearance",
        "form_aspect_eau_1": "Clear transparent water",
        "form_aspect_eau_2": "Cloudy water",
        "form_aspect_eau_3": "Green water",

        "form_temperature_eau": "Water temperature",
        "form_temperature_eau_1": "Temperature in °C",

        "form_valeur_mesure": "Measured values",
        "form_valeur_input_manual": "I enter the values manually",
        "form_valeur_input_manual_tooltip": "Enter values manually",
        "form_valeur_input_spintouch": "I connect to the SpinTouch",
        "form_valeur_input_spintouch_tooltip": "Connect to SpinTouch",
        "form_valeur_input_spintouch_disabled": "Use Esprit Piscine software on Windows",
        "form_valeur_mesure_PH": "pH value",
        "form_valeur_mesure_CL": "Free chlorine level (mg/L)",
        "form_valeur_mesure_BR": "Bromine content (mg/L)",
        "form_valeur_mesure_TAC": "Alkalinity or TAC (mg/L)",
        "form_valeur_mesure_TAC_facultatif": "(Optional)", 
        "form_valeur_mesure_TH": "Total hardness or TH (mg/L)",
        "form_valeur_mesure_TH_facultatif": "",
        "form_valeur_mesure_STAB": "Stabilizer (mg/L)",
        "form_valeur_mesure_Phosphate": "Phosphate in ppb",

        "form_valeur_button": "I analyze",

        "simul_volTitre1": "Calculate the water volume",
        "simul_volTitre2": "of your pool or spa (m³)",

        "simul_vol2Titre1": "Shape",
        "simul_vol2Titre2": " of your pool :",

        "simul_vol3Titre1": "Dimensions de votre bassin",
        "simul_vol3Titre2": " of your pool :",

        "simul_Rectangle": "",
        "simul_Ovale": "",
        "simul_Ronde": "",
       

        "simul_Longueur": "Length (m)",
        "simul_Largeur": "Width (m)",
        "simul_Profondeur": "Depth (m)",
        "simul_ProfondeurMini": "Minimum depth (m)",
        "simul_ProfondeurMaxi": "Maximum depth (m)",
        "simul_Diametre": "Diameter (m)",

        "simul_Button": "I analyze",
        "simul_Button2": "I calculate",

        "histo_search": "Search by data, name, etc..",


        "analyse_title1": "Pool data / Pool information",
     
        "analyse_info_volume": "Pool volume :	",
        "analyse_info_type_filtration": "Filtration type : ",
        "analyse_info_type_desinfection": "Disinfection type :	",
        "analyse_info_temperature_eau": "Water temperature : ",

        "analyse_titleResultat": "Analysis result",

        "analyse_resulat_ideal": "ideal : ",

         "analyse_resulat_download" : "Download the analysis",
         "analyse_resulat_share" : "Share the analysis",
           "analyse_resulat_new" : "New analysis",

          "historique_message_supression_title" : "Delete the analysis",
          "historique_message_supression_description" : "Delete the analysis?",

          "historique_message_supression_button_annuler" : "Cancel",
          "historique_message_supression_button_supprimer" : "Delete",

          "analyse_TempsFiltration" : "Filtration time",


           "simul_Forme_Rectangle" : "Rectangle",
          "simul_Forme_Oval" : "Oval",
          "simul_Forme_Ronde" : "Round",
          "simul_Forme_Autre" : "Other shape",
          "form_spintouch_non_detect": "No detailed results returned by the device. Check the device connection.",
          "validation_volume_bassin": "Enter the volume of your pool",
          "validation_type_filtration": "Select a filtration type",
          "validation_temps_filtration": "Enter the daily filtration time of your pool in hours",
          "validation_type_desinfection": "Select a disinfection type",
          "validation_eau_calcaire": "Complete the hard water section",
          "validation_aspect_eau": "Select the water appearance",
          "validation_temperature_eau": "Enter the water temperature of your pool",
          "validation_niveau_chlore": "Enter the chlorine level of your pool",
          "validation_analyse_en_cours": "Analysis in progress...",
          "validation_erreur_analyse": "Error during analysis",
          "simul_validation_type_forme": "Select the shape type of your pool",
          "simul_validation_longueur": "Enter the length of the pool",
          "simul_validation_largeur": "Enter the width of the pool",
          "simul_validation_profondeur_mini": "Enter the minimum depth of the pool",
          "simul_validation_profondeur_maxi": "Enter the maximum depth of the pool",
          "simul_validation_diametre": "Enter the diameter of the pool",
          "simul_resultat_volume": "Your pool has a water volume of:",




      }
    },

    de: {
      translation: {
        "hero_title1": "Die Analyseanwendung",
        "hero_title2": "für die Poolwartung",
        "menu_analyse": "Analyse",
        "menu_calcul_volume": "Volumenberechnung",
        "menu_historique": "Verordnungen",
        "menu_login": "Abmelden",
        "menu_update_available": "Aktualisierung verfügbar",
        "menu_update_current": "Aktuell",
        "menu_update_checking": "Überprüfung...",
        "menu_update_error": "Prüfung fehlgeschlagen",
        "menu_update_app_current": "Die Anwendung ist auf dem neuesten Stand",
        "menu_update_download": "Neueste Version herunterladen",
        "home_analyse": "Ich analysiere",
        "home_calcule": "Ich berechne",
        "home_enregistre": "Ich speichere",
        "home_admin": "Verwaltung",

        "home_spintouch": "Spintouch",
        "form_pref_placecorder": "Referenz, name, firma ...",
        "form_volume_bassin": "Beckenvolumen",
        "form_volume_bassin_1": "Ich kenne das Volumen",
        "form_volume_bassin_2": "Ich kenne das Volumen nicht",
        "form_volume_bassin_3": "Ich berechne",

        "form_periode_analyse": "Analysezeitraum",
        "form_periode_analyse_1": "zu Beginn der Saison",
        "form_periode_analyse_2": "im Laufe der Saison",

        "form_type_filtration": "Filtertyp",
        "form_type_filtration_1": "Sandfilter",
        "form_type_filtration_2": "Kieselgurfilter",
        "form_type_filtration_3": "Kartuschenfilter",
        "form_type_filtration_4": "Filterbeutel",
        "form_type_filtration_5": "Tägliche Filterzeit (in Stunden)",
        "form_type_filtration_6": "Dauer in Stunden",

        "form_type_desinfection": "Desinfektionstyp",
        "form_type_desinfection_1": "Chlortablette",
        "form_type_desinfection_2": "Flüssigchlor",
        "form_type_desinfection_3": "Salzelektrolysegerät",
        "form_type_desinfection_4": "Empfohlener Salzgehalt des Geräts (g/L)",

        "form_type_eau_calcaire": "Kalkhaltiges Wasser",
        "form_type_eau_calcaire_1": "Mäßig hartes Wasser",
        "form_type_eau_calcaire_1_1": "TH unter 200 mg/L (20°F)",
        "form_type_eau_calcaire_2": "Hartes Wasser",
        "form_type_eau_calcaire_2_2": "TH über 200 mg/L (20°F)",
        "form_type_eau_calcaire_3": "Sehr hartes Wasser",
        "form_type_eau_calcaire_3_3": "TH über 400 mg/L (40°F)",
        "form_type_eau_calcaire_4": "Ich weiß nicht",

        "form_aspect_eau": "Wasserbeschaffenheit",
        "form_aspect_eau_1": "Klares transparentes Wasser",
        "form_aspect_eau_2": "Trübes Wasser",
        "form_aspect_eau_3": "Grünes Wasser",

        "form_temperature_eau": "Wassertemperatur",
        "form_temperature_eau_1": "Temperatur in °C	",

        "form_valeur_mesure": "Gemessene Werte",
        "form_valeur_input_manual": "Ich gebe die Werte manuell ein",
        "form_valeur_input_manual_tooltip": "Werte manuell eingeben",
        "form_valeur_input_spintouch": "Ich verbinde mich mit dem SpinTouch",
        "form_valeur_input_spintouch_tooltip": "Mit SpinTouch verbinden",
        "form_valeur_input_spintouch_disabled": "Esprit Piscine-Software unter Windows verwenden",
        "form_valeur_mesure_PH": "pH-Wert",
        "form_valeur_mesure_CL": "Gehalt an freiem Chlor (mg/L)",
        "form_valeur_mesure_BR": "Bromgehalt (mg/L)",
        "form_valeur_mesure_TAC": "Alkalinität oder TAC (mg/L)",
        "form_valeur_mesure_TAC_facultatif": "(Fakultativ)",
        "form_valeur_mesure_TH": "Gesamthärte oder TH (mg/L)",
        "form_valeur_mesure_TH_facultatif": "",
        "form_valeur_mesure_STAB": "Stabilisator (mg/L)",
        "form_valeur_mesure_Phosphate": "Phosphat in ppb",

        "form_valeur_button": "Ich analysiere",

        "simul_volTitre1": "Wasservolumen berechnen",
        "simul_volTitre2": "Ihres Pools oder Whirlpools (m³)",

        "simul_vol2Titre1": "Form",
        "simul_vol2Titre2": " Ihres Beckens:",

        "simul_vol3Titre1": "Maße",
        "simul_vol3Titre2":" Ihres Beckens:",

        "simul_Rectangle": "",
        "simul_Ovale": "",
        "simul_Ronde": "",
       

        "simul_Longueur": "Länge (m)",
        "simul_Largeur": "Breite (m)",
        "simul_Profondeur": "Tiefe (m)",
        "simul_ProfondeurMini": "Mindesttiefe (m)",
        "simul_ProfondeurMaxi": "Maximale Tiefe (m)",
        "simul_Diametre": "Durchmesser (m)",

        "simul_Button": "Ich analysiere",
        "simul_Button2": "Ich berechne",

        "histo_search": "Nach Daten, Name usw. suchen..",

        "analyse_title1": "Beckendaten / Poolinformationen",
        

        "analyse_info_volume": "Beckenvolumen	: ",
        "analyse_info_type_filtration": "Filtertyp : ",
        "analyse_info_type_desinfection": "Desinfektionstyp :	",
        "analyse_info_temperature_eau": "Wassertemperatur :	",

        "analyse_titleResultat": "Analyseergebnis",

        "analyse_resulat_ideal": "ideal : ",

        "analyse_resulat_download" : "Analyse herunterladen",
        "analyse_resulat_share" : "Analyse teilen",
        "analyse_resulat_new" : "Neue Analyse",
        "historique_message_supression_title" : "Analyse löschen",
         "historique_message_supression_description" : "Analyse löschen?",

         "historique_message_supression_button_annuler" : "Abbrechen",
         "historique_message_supression_button_supprimer" : "Löschen",

         "analyse_TempsFiltration" : "Filterzeit",

          "simul_Forme_Rectangle" : "Rechteck",
          "simul_Forme_Oval" : "Oval",
          "simul_Forme_Ronde" : "Rund",
          "simul_Forme_Autre" : "Andere Form",
          "form_spintouch_non_detect": "Keine detaillierten Ergebnisse vom Gerät zurückgegeben. Überprüfen Sie die Verbindung des Geräts.",
          "validation_volume_bassin": "Geben Sie das Volumen Ihres Beckens ein",
          "validation_type_filtration": "Wählen Sie einen Filtertyp",
          "validation_temps_filtration": "Geben Sie die tägliche Filterzeit Ihres Beckens in Stunden ein",
          "validation_type_desinfection": "Wählen Sie einen Desinfektionstyp",
          "validation_eau_calcaire": "Vervollständigen Sie den Abschnitt kalkhaltiges Wasser",
          "validation_aspect_eau": "Wählen Sie die Wasserbeschaffenheit",
          "validation_temperature_eau": "Geben Sie die Wassertemperatur Ihres Beckens ein",
          "validation_niveau_chlore": "Geben Sie den Chlorgehalt Ihres Beckens ein",
          "validation_analyse_en_cours": "Analyse läuft...",
          "validation_erreur_analyse": "Fehler bei der Analyse",
          "simul_validation_type_forme": "Wählen Sie die Form Ihres Beckens",
          "simul_validation_longueur": "Geben Sie die Länge des Beckens ein",
          "simul_validation_largeur": "Geben Sie die Breite des Beckens ein",
          "simul_validation_profondeur_mini": "Geben Sie die Mindesttiefe des Beckens ein",
          "simul_validation_profondeur_maxi": "Geben Sie die maximale Tiefe des Beckens ein",
          "simul_validation_diametre": "Geben Sie den Durchmesser des Beckens ein",
          "simul_resultat_volume": "Ihr Becken hat ein Wasservolumen von:",


        
      }
    },

    es: {
      translation: {
        "hero_title1": "La aplicación de análisis",
        "hero_title2": "para el mantenimiento de piscinas",
        "menu_analyse": "Análisis",
        "menu_calcul_volume": "Cálculo del volumen",
        "menu_historique": "Ordinanze",
        "menu_login": "Cerrar sesión",
        "menu_update_available": "Actualización disponible",
        "menu_update_current": "Al día",
        "menu_update_checking": "Verificando...",
        "menu_update_error": "Error de verificación",
        "menu_update_app_current": "La aplicación está actualizada",
        "menu_update_download": "Descargar la última versión",
        "home_analyse": "Analizo",
        "home_calcule": "Calculo",
        "home_enregistre": "Guardo",
        "home_admin": "Administración",

        "home_spintouch": "Spintouch",
        "form_pref_placecorder": "Referencia, mombre, empresa ...",
        "form_volume_bassin": "Volumen de la piscina",
        "form_volume_bassin_1": "Conozco el volumen	",
        "form_volume_bassin_2": "No conozco el volumen",
        "form_volume_bassin_3": "Calculo",

        "form_periode_analyse": "Período de análisis",
        "form_periode_analyse_1": "al comienzo de la temporada",
        "form_periode_analyse_2": "durante la temporada",

        "form_type_filtration": "Tipo de filtración",
        "form_type_filtration_1": "Filtro de arena",
        "form_type_filtration_2": "Filtro de diatomeas",
        "form_type_filtration_3": "Filtro de cartucho",
        "form_type_filtration_4": "Bolsa de filtración",
        "form_type_filtration_5": "Tiempo de filtración diario (en horas)",
        "form_type_filtration_6": "Duración en horas",

        "form_type_desinfection": "Tipo de desinfección",
        "form_type_desinfection_1": "Cloro en pastillas",
        "form_type_desinfection_2": "Cloro líquido",
        "form_type_desinfection_3": "Clorador salino",
        "form_type_desinfection_4": "Nivel de sal recomendado por el dispositivo (g/L)",

        "form_type_eau_calcaire": "Agua calcárea",
        "form_type_eau_calcaire_1": "Agua medianamente dura",
        "form_type_eau_calcaire_1_1": "TH inferior a 200 mg/L (20°F)",
        "form_type_eau_calcaire_2": "Agua dura",
        "form_type_eau_calcaire_2_2": "TH superior a 200 mg/L (20°F)",
        "form_type_eau_calcaire_3": "Agua muy dura",
        "form_type_eau_calcaire_3_3": "TH superior a 400 mg/L (40°F)",
        "form_type_eau_calcaire_4": "No lo sé",

        "form_aspect_eau": "Aspecto del agua",
        "form_aspect_eau_1": "Agua clara y transparente",
        "form_aspect_eau_2": "Agua turbia",
        "form_aspect_eau_3": "Agua verde",

        "form_temperature_eau": "Temperatura del agua",
        "form_temperature_eau_1": "Temperatura en °C",

        "form_valeur_mesure": "Valores medidos",
        "form_valeur_input_manual": "Introduzco los valores manualmente",
        "form_valeur_input_manual_tooltip": "Introducir valores manualmente",
        "form_valeur_input_spintouch": "Me conecto al SpinTouch",
        "form_valeur_input_spintouch_tooltip": "Conectarse al SpinTouch",
        "form_valeur_input_spintouch_disabled": "Usar el software Esprit Piscine en Windows",
        "form_valeur_mesure_PH": "Valor de pH",
        "form_valeur_mesure_CL": "Nivel de cloro libre (mg/L)",
        "form_valeur_mesure_BR": "Contenido de bromo (mg/L)",
        "form_valeur_mesure_TAC": "Alcalinidad o TAC (mg/L)",
        "form_valeur_mesure_TAC_facultatif": "(Opcional)",
        "form_valeur_mesure_TH": "Dureza total o TH (mg/L)",
        "form_valeur_mesure_TH_facultatif": "(Opcional)",
        "form_valeur_mesure_STAB": "Estabilizante (mg/L)",
        "form_valeur_mesure_Phosphate": "Fosfato en ppb",

        "form_valeur_button": "Analizo",

        "simul_volTitre1": "Calcular el volumen de agua",
        "simul_volTitre2": "de su piscina o spa (m³)",

        "simul_vol2Titre1": "Forma",
        "simul_vol2Titre2": " de su piscina:",

        "simul_vol3Titre1": "Dimensiones",
        "simul_vol3Titre2": " de su piscina:",

        "simul_Rectangle": "",
        "simul_Ovale": "",
        "simul_Ronde": "",
       

        "simul_Longueur": "Longitud (m)",
        "simul_Largeur": "Ancho (m)",
        "simul_Profondeur": "Profundidad (m)",
        "simul_ProfondeurMini": "Profundidad mínima (m)",
        "simul_ProfondeurMaxi": "Profundidad máxima (m)",
        "simul_Diametre": "Diámetro (m)",

        "simul_Button": "Yo analizo",
        "simul_Button2": "Yo calculo",

        "histo_search": "Buscar por datos, nombre, etc..",

        "analyse_title1": "Datos de su piscina",
        "analyse_info_volume": "Volumen de la piscina	: ",

        "analyse_info_type_filtration": "Tipo de filtración :	",
        "analyse_info_type_desinfection": "Tipo de desinfección :	",
        "analyse_info_temperature_eau": "Temperatura del agua : ",
        "analyse_titleResultat": "Resultado del análisis",
        
        "analyse_resulat_ideal": "ideal : ",
        "analyse_resulat_download" : "Descargar el análisis",
        "analyse_resulat_share" : "Compartir el análisis",
        "analyse_resulat_new" : "Nuevo análisis",
        "historique_message_supression_title" : "Eliminar el análisis",
         "historique_message_supression_description" : "¿Eliminar el análisis?",

         "historique_message_supression_button_annuler" : "Cancelar",
         "historique_message_supression_button_supprimer" : "Eliminar",

         "analyse_TempsFiltration" : "Tiempo de filtración",

          "simul_Forme_Rectangle" : "Rectángulo",
          "simul_Forme_Oval" : "Ovalado",
          "simul_Forme_Ronde" : "Redonda",
          "simul_Forme_Autre" : "Otra forma",
          "form_spintouch_non_detect": "No se han devuelto resultados detallados por el dispositivo. Verifique la conexión del dispositivo.",
          "validation_volume_bassin": "Introduzca el volumen de su piscina",
          "validation_type_filtration": "Seleccione un tipo de filtración",
          "validation_temps_filtration": "Introduzca el tiempo de filtración diario de su piscina en horas",
          "validation_type_desinfection": "Seleccione un tipo de desinfección",
          "validation_eau_calcaire": "Complete la sección de agua calcárea",
          "validation_aspect_eau": "Seleccione el aspecto del agua",
          "validation_temperature_eau": "Introduzca la temperatura del agua de su piscina",
          "validation_niveau_chlore": "Introduzca el nivel de cloro de su piscina",
          "validation_analyse_en_cours": "Análisis en curso...",
          "validation_erreur_analyse": "Error durante el análisis",
          "simul_validation_type_forme": "Seleccione el tipo de forma de su piscina",
          "simul_validation_longueur": "Introduzca la longitud de la piscina",
          "simul_validation_largeur": "Introduzca el ancho de la piscina",
          "simul_validation_profondeur_mini": "Introduzca la profundidad mínima de la piscina",
          "simul_validation_profondeur_maxi": "Introduzca la profundidad máxima de la piscina",
          "simul_validation_diametre": "Introduzca el diámetro de la piscina",
          "simul_resultat_volume": "Su piscina tiene un volumen de agua de:",

      }
    },

    it: {
      translation: {
        "hero_title1": "L'applicazione di analisi",
        "hero_title2": "per la manutenzione delle piscine",
        "menu_analyse": "Analisi",
        "menu_calcul_volume": "Calcolo del volume",
        "menu_historique": "Órdenes",
        "menu_login": "Disconnettersi",
        "menu_update_available": "Aggiornamento disponibile",
        "menu_update_current": "Aggiornato",
        "menu_update_checking": "Verifica...",
        "menu_update_error": "Verifica fallita",
        "menu_update_app_current": "L'applicazione è aggiornata",
        "menu_update_download": "Scarica l'ultima versione",
        "home_analyse": "Analizzo",
        "home_calcule": "Calcolo",
        "home_enregistre": "Registro",
        "home_admin": "Amministrazione",

        "home_spintouch": "Spintouch",
        "form_pref_placecorder": "Riferimento, mome, società ...",
        "form_volume_bassin": "Volume della piscina",
        "form_volume_bassin_1": "Conosco il volume",
        "form_volume_bassin_2": "Non conosco il volume",
        "form_volume_bassin_3": "Calcolo",

        "form_periode_analyse": "Periodo di analisi",
        "form_periode_analyse_1": "all'inizio della stagione",
        "form_periode_analyse_2": "durante la stagione",

        "form_type_filtration": "Tipo di filtrazione",
        "form_type_filtration_1": "Filtro a sabbia",
        "form_type_filtration_2": "Filtro a diatomee",
        "form_type_filtration_3": "Filtro a cartuccia",
        "form_type_filtration_4": "Sacco filtrante",
        "form_type_filtration_5": "Tempo di filtrazione giornaliero (in ore)",
        "form_type_filtration_6": "Durata in ore",

        "form_type_desinfection": "Tipo di disinfezione",
        "form_type_desinfection_1": "Cloro in pastiglie",
        "form_type_desinfection_2": "Cloro liquido",
        "form_type_desinfection_3": "Elettrolizzatore a sale",
        "form_type_desinfection_4": "Livello di sale raccomandato dal dispositivo (g/L)",

        "form_type_eau_calcaire": "Acqua calcarea",
        "form_type_eau_calcaire_1": "Acqua mediamente dura",
        "form_type_eau_calcaire_1_1": "TH inferiore a 200 mg/L (20°F)",
        "form_type_eau_calcaire_2": "Acqua dura",
        "form_type_eau_calcaire_2_2": "TH superiore a 200 mg/L (20°F)",
        "form_type_eau_calcaire_3": "Acqua molto dura",
        "form_type_eau_calcaire_3_3": "TH superiore a 400 mg/L (40°F)",
        "form_type_eau_calcaire_4": "Non lo so",

        "form_aspect_eau": "Aspetto dell'acqua",
        "form_aspect_eau_1": "Acqua chiara e trasparente",
        "form_aspect_eau_2": "Acqua torbida",
        "form_aspect_eau_3": "Acqua verde",

        "form_temperature_eau": "Temperatura dell'acqua",
        "form_temperature_eau_1": "Temperatura in °C",

        "form_valeur_mesure": "Valori misurati",
        "form_valeur_input_manual": "Inserisco i valori manualmente",
        "form_valeur_input_manual_tooltip": "Inserire valori manualmente",
        "form_valeur_input_spintouch": "Mi connetto al SpinTouch",
        "form_valeur_input_spintouch_tooltip": "Connettersi al SpinTouch",
        "form_valeur_input_spintouch_disabled": "Utilizzare il software Esprit Piscine su Windows",
        "form_valeur_mesure_PH": "Valore del pH",
        "form_valeur_mesure_CL": "Livello di cloro libero (mg/L)",
        "form_valeur_mesure_BR": "Contenuto di bromo (mg/L)",
        "form_valeur_mesure_TAC": "Alcalinità o TAC (mg/L)",
        "form_valeur_mesure_TAC_facultatif": "(Facoltativo)",
        "form_valeur_mesure_TH": "Durezza totale o TH (mg/L)",
        "form_valeur_mesure_TH_facultatif":"(Facoltativo)",
        "form_valeur_mesure_STAB": "Stabilizzante (mg/L)",
        "form_valeur_mesure_Phosphate": "Fosfato in ppb",

        "form_valeur_button": "Analizzo",

        "simul_volTitre1": "Calcolare il volume dell'acqua",
        "simul_volTitre2": "della tua piscina o spa (m³)",

        "simul_vol2Titre1": "Forma",
        "simul_vol2Titre2": " della tua piscina:",

        "simul_vol3Titre1": "Dimensioni",
        "simul_vol3Titre2": " della tua piscina:",

        "simul_Rectangle": "",
        "simul_Ovale": "",
        "simul_Ronde": "",


        "simul_Longueur": "Lunghezza (m)",
        "simul_Largeur": "Larghezza (m)",
        "simul_Profondeur": "Profondità (m)",
        "simul_ProfondeurMini": "Profondità minima (m)",
        "simul_ProfondeurMaxi": "Profondità massima (m)",
        "simul_Diametre": "Diametro (m)",

        "simul_Button": "Io analizzo",
        "simul_Button2": "Io calcolo",

        "histo_search": "Cercare per dati, nome, ecc..",

        "analyse_title1": "Dati della tua piscina",
        "analyse_info_volume": "Volume della piscina : ",
        "analyse_info_type_filtration": "Tipo di filtrazione : ",
        "analyse_info_type_desinfection": "Tipo di disinfezione : ",
        "analyse_info_temperature_eau": "Temperatura dell'acqua : ",
        "analyse_titleResultat": "Risultato dell'analisi",

        "analyse_resulat_ideal": "ideale : ",
        "analyse_resulat_download" : "Scarica l’analisi",
        "analyse_resulat_share" : "Condividi l’analisi",
        "analyse_resulat_new" : "Nuova analisi",

        "historique_message_supression_title" : "Elimina l’analisi",
        "historique_message_supression_description" : "Eliminare l’analisi?",

        "historique_message_supression_button_annuler" : "Annulla",
        "historique_message_supression_button_supprimer" : "Elimina",

        "analyse_TempsFiltration" : "Tempo di filtrazione",

         "simul_Forme_Rectangle" : "Rettangolo",
          "simul_Forme_Oval" : "Ovale",
          "simul_Forme_Ronde" : "Rotonda",
          "simul_Forme_Autre" : "Altra forma",
          "form_spintouch_non_detect": "Non sono stati restituiti risultati dettagliati dal dispositivo. Verificare la connessione del dispositivo.",
          "validation_volume_bassin": "Inserire il volume della piscina",
          "validation_type_filtration": "Selezionare un tipo di filtrazione",
          "validation_temps_filtration": "Inserire il tempo di filtrazione giornaliero della piscina in ore",
          "validation_type_desinfection": "Selezionare un tipo di disinfezione",
          "validation_eau_calcaire": "Completare la sezione acqua calcarea",
          "validation_aspect_eau": "Selezionare l'aspetto dell'acqua",
          "validation_temperature_eau": "Inserire la temperatura dell'acqua della piscina",
          "validation_niveau_chlore": "Inserire il livello di cloro della piscina",
          "validation_analyse_en_cours": "Analisi in corso...",
          "validation_erreur_analyse": "Errore durante l'analisi",
          "simul_validation_type_forme": "Selezionare il tipo di forma della piscina",
          "simul_validation_longueur": "Inserire la lunghezza della piscina",
          "simul_validation_largeur": "Inserire la larghezza della piscina",
          "simul_validation_profondeur_mini": "Inserire la profondità minima della piscina",
          "simul_validation_profondeur_maxi": "Inserire la profondità massima della piscina",
          "simul_validation_diametre": "Inserire il diametro della piscina",
          "simul_resultat_volume": "La vostra piscina ha un volume d'acqua di:",

      }
    },

  "pt-PT": {
    translation: {
      "hero_title1": "A aplicação de análise",
      "hero_title2": "para a manutenção de piscinas",

      "menu_analyse": "Análise",
      "menu_calcul_volume": "Cálculo do volume",
      "menu_historique": "Recomendações",
      "menu_login": "Terminar sessão",
      "menu_update_available": "Atualização disponível",
      "menu_update_current": "Atualizado",
      "menu_update_checking": "Verificando...",
      "menu_update_error": "Falha na verificação",
      "menu_update_app_current": "A aplicação está atualizada",
      "menu_update_download": "Descarregar a versão mais recente",

      "home_analyse": "Analiso",
      "home_calcule": "Calculo",
      "home_enregistre": "Recomendações",
      "home_admin": "Administração",

      "home_spintouch": "Spintouch",
      "form_pref_placecorder": "Referência, nome, empresa ...",
      "form_volume_bassin": "Volume da piscina",
      "form_volume_bassin_1": "Conheço o volume",
      "form_volume_bassin_2": "Não conheço o volume",
      "form_volume_bassin_3": "Calculo",

      "form_periode_analyse": "Período de análise",
      "form_periode_analyse_1": "no início da temporada",
      "form_periode_analyse_2": "durante a temporada",

      "form_type_filtration": "Tipo de filtração",
      "form_type_filtration_1": "filtro de areia / vidro",
      "form_type_filtration_2": "filtro de diatomáceas",
      "form_type_filtration_3": "filtro de cartucho",
      "form_type_filtration_4": "bolsa de filtração",
      "form_type_filtration_5": "Tempo de filtração diário (em horas)",
      "form_type_filtration_6": "Duração em horas",

      "form_type_desinfection": "Tipo de desinfeção",
      "form_type_desinfection_1": "cloro em pastilhas",
      "form_type_desinfection_2": "cloro líquido",
      "form_type_desinfection_3": "eletrolisador de sal",
      "form_type_desinfection_4": "Taxa de sal recomendada pelo aparelho (em g/L)",

      "form_type_eau_calcaire": "Água calcária",
      "form_type_eau_calcaire_1": "água moderadamente dura",
      "form_type_eau_calcaire_1_1": "TH inferior a 200mg/L (20°F)",
      "form_type_eau_calcaire_2": "água dura",
      "form_type_eau_calcaire_2_2": "TH superior a 200mg/L (20°F)",
      "form_type_eau_calcaire_3": "água muito dura",
      "form_type_eau_calcaire_3_3": "TH superior a 400mg/L (40°F)",
      "form_type_eau_calcaire_4": "não sei",

      "form_aspect_eau": "Aspeto da água",
      "form_aspect_eau_1": "água clara e transparente",
      "form_aspect_eau_2": "água turva",
      "form_aspect_eau_3": "água verde",

      "form_temperature_eau": "Temperatura da água",
      "form_temperature_eau_1": "Temperatura em °C",

      "form_valeur_mesure": "Valores medidos",
      "form_valeur_input_manual": "Introduzo os valores manualmente",
      "form_valeur_input_manual_tooltip": "Introduzir valores manualmente",
      "form_valeur_input_spintouch": "Conecto-me ao SpinTouch",
      "form_valeur_input_spintouch_tooltip": "Conectar ao SpinTouch",
      "form_valeur_input_spintouch_disabled": "Usar o software Esprit Piscine no Windows",
      "form_valeur_mesure_PH": "Valor de pH",
      "form_valeur_mesure_CL": "Teor de cloro livre (mg/L)",
      "form_valeur_mesure_BR": "Teor de bromo (mg/L)",
      "form_valeur_mesure_TAC": "Alcalinidade ou TAC (mg/L)",
      "form_valeur_mesure_TAC_facultatif": "(facultativo)",
      "form_valeur_mesure_TH": "Dureza total ou TH (mg/L)",
      "form_valeur_mesure_TH_facultatif": "(facultativo)",
      "form_valeur_mesure_STAB": "Estabilizador (mg/L)",
      "form_valeur_mesure_Phosphate": "Fosfato em ppb",

      "form_valeur_button": "Analiso",

      "simul_volTitre1": "Calcular o volume de água",
      "simul_volTitre2": "da sua piscina ou SPA (m³)",

      "simul_vol2Titre1": "Forma",
      "simul_vol2Titre2": " da sua piscina:",

      "simul_vol3Titre1": "Dimensões",
      "simul_vol3Titre2": " da sua piscina:",

      "simul_Rectangle": "Retângulo",
      "simul_Ovale": "Oval",
      "simul_Ronde": "Redonda",

      "simul_Longueur": "Comprimento (m)",
      "simul_Largeur": "Largura (m)",
      "simul_Profondeur": "Profundidade (m)",
      "simul_ProfondeurMini": "Profundidade mínima (m)",
      "simul_ProfondeurMaxi": "Profundidade máxima (m)",
      "simul_Diametre": "Diâmetro (m)",

      "simul_Button": "Analiso",
      "simul_Button2": "Calculo",

      "histo_search": "Pesquisar por data, nome, etc..",

      "analyse_title1": "Dados da piscina",
      "analyse_info_volume": "Volume da piscina: ",
      "analyse_info_type_filtration": "Tipo de filtração: ",
      "analyse_info_type_desinfection": "Tipo de desinfeção: ",
      "analyse_info_temperature_eau": "Temperatura da água: ",

      "analyse_titleResultat": "Resultado da análise",
      "analyse_resulat_ideal": "ideal: ",

      "analyse_resulat_download": "Descarregar a análise",
      "analyse_resulat_share": "Partilhar a análise",
      "analyse_resulat_new": "Nova análise",

      "historique_message_supression_title": "Eliminar análise",
      "historique_message_supression_description": "Eliminar a análise?",

      "historique_message_supression_button_annuler": "Cancelar",
      "historique_message_supression_button_supprimer": "Eliminar",

      "analyse_TempsFiltration": "Tempo de filtração",
       "simul_Forme_Rectangle" : "Retângulo",
          "simul_Forme_Oval" : "Oval",
          "simul_Forme_Ronde" : "Redonda",
          "simul_Forme_Autre" : "Outra forma",
          "form_spintouch_non_detect": "Não foram devolvidos resultados detalhados pelo dispositivo. Verifique a conexão do dispositivo.",
          "validation_volume_bassin": "Introduza o volume da piscina",
          "validation_type_filtration": "Selecione um tipo de filtração",
          "validation_temps_filtration": "Introduza o tempo de filtração diário da piscina em horas",
          "validation_type_desinfection": "Selecione um tipo de desinfeção",
          "validation_eau_calcaire": "Complete a secção de água calcária",
          "validation_aspect_eau": "Selecione o aspeto da água",
          "validation_temperature_eau": "Introduza a temperatura da água da piscina",
          "validation_niveau_chlore": "Introduza o nível de cloro da piscina",
          "validation_analyse_en_cours": "Análise em curso...",
          "validation_erreur_analyse": "Erro durante a análise",
          "simul_validation_type_forme": "Selecione o tipo de forma da piscina",
          "simul_validation_longueur": "Introduza o comprimento da piscina",
          "simul_validation_largeur": "Introduza a largura da piscina",
          "simul_validation_profondeur_mini": "Introduza a profundidade mínima da piscina",
          "simul_validation_profondeur_maxi": "Introduza a profundidade máxima da piscina",
          "simul_validation_diametre": "Introduza o diâmetro da piscina",
          "simul_resultat_volume": "A sua piscina tem um volume de água de:",
    }
  }

};

i18n.use(initReactI18next).init({
  resources,
  lng: "fr", // Langue par défaut
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false
  }
});

export default i18n;